import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../service/api";

// Submit onboarding form
export const submitOnboardingForm = createAsyncThunk(
  "onboarding/submitForm",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`api/onboarding/form/create`, formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Error submitting form"
      );
    }
  }
);

// Get all onboarding forms
export const getOnboardingForms = createAsyncThunk(
  "onboarding/getForms",
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `api/onboarding/form/get?page=${page}&limit=${limit}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch responses"
      );
    }
  }
);

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    pagination: { page: 1, pages: 1, total: 0 },
    forms: [],

    fetchLoading: false,
    fetchError: null,
    fetchSuccess: false,

    loading: false,
    success: false,
    error: null,
    form: null,
  },
  reducers: {
    resetOnboarding: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.form = null;
    },
  },
  extraReducers: (builder) => {
    // Submit onboarding form
    builder
      .addCase(submitOnboardingForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitOnboardingForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.form = action.payload.data;
      })
      .addCase(submitOnboardingForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Get all onboarding forms
    builder
      .addCase(getOnboardingForms.pending, (state) => {
        state.fetchLoading = true;
        state.fetchError = null;
      })
      .addCase(getOnboardingForms.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.fetchSuccess = true;
        state.forms = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getOnboardingForms.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchSuccess = false;
        state.fetchError = action.payload;
      });
  },
});

export const { resetOnboarding } = onboardingSlice.actions;
export default onboardingSlice.reducer;
